import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { get } from '../core';
import { css } from '../style-system';
var animationProps = {
  transitionDuration: get('transitionDuration'),
  transitionProperty: 'all',
  transitionTimingFunction: 'ease-in-out'
};
/**
 * @param {import('create-emotion').ObjectInterpolation<any>['transition']} transition
 * @return {string}
 */

export var animation = function (transition) {
  return css({
    transition: transition
  });
};
animation.default = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'ease'
}));
animation.bounce = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'cubic-bezier(.8, .5, .2, 1.4)'
}));

animation.delay = function (value) {
  return css({
    transitionDelay: value + "s"
  });
};

animation.duration = function (value) {
  return css({
    transitionDuration: value + "s"
  });
};

animation.ease = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'ease'
}));
animation.easeIn = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'ease-in'
}));
animation.easeInOut = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'ease-in-out'
}));
animation.easeOut = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'ease-out'
}));

animation.easing = function (value) {
  return css(_objectSpread(_objectSpread({}, animationProps), {}, {
    transitionTimingFunction: value
  }));
};

animation.linear = css(_objectSpread(_objectSpread({}, animationProps), {}, {
  transitionTimingFunction: 'linear'
}));